(function () {
  class PotDisplay extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      StateMachine.Create(this);

      messageBus.subscribe('stake:stakeChanged', this.onStakeChanged.bind(this));
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    initialise() {
      this._jsonPath = this.name + ':potDisplayContainer';
      this._potTextMini = undefined;
      this._potTextMinor = undefined;
      this._potTextMaxi = undefined;
      this._potTextMajor = undefined;
      this._potTextPorker = undefined;
      this._potTextMega = undefined;
      this._potTextLeftMini = undefined;
      this._potTextLeftMinor = undefined;
      this._potTextLeftMaxi = undefined;
      this._potTextLeftMajor = undefined;
      this._potTextLeftPorker = undefined;
      this._potTextLeftMega = undefined;

      this._potPanels = [];
      this._potPanelGlows = [];

      this._potMultiplierMini = 0;
      this._potMultiplierMinor = 0;
      this._potMultiplierMaxi = 0;
      this._potMultiplierMajor = 0;
      this._potMultiplierPorker = 0;
      this._potMultiplierMega = 0;

      this._potValueMini = 0;
      this._potValueMinor = 0;
      this._potValueMaxi = 0;
      this._potValueMajor = 0;
      this._potValuePorker = 0;
      this._potValueMega = 0;

      this._potDappleID = 0;
      this._winningDiscPot = 0;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
    }

    onGameConfigEvent(task) {
      // Values supplied by the server are double the actual pot values
      this._potMultiplierMini = task.data.miniJackpot / 2;
      this._potMultiplierMinor = task.data.minorJackpot / 2;
      this._potMultiplierMaxi = task.data.maxiJackpot / 2;
      this._potMultiplierMajor = task.data.majorJackpot / 2;
      this._potMultiplierPorker = task.data.porkerJackpot / 2;
      this._potMultiplierMega = task.data.megaJackpot / 2;

      this._potPanels.push(resourceManager.get(this._jsonPath + ':cashpotMeters:miniPanelParent'));
      this._potPanels.push(resourceManager.get(this._jsonPath + ':cashpotMeters:minorPanelParent'));
      this._potPanels.push(resourceManager.get(this._jsonPath + ':cashpotMeters:maxiPanelParent'));
      this._potPanels.push(resourceManager.get(this._jsonPath + ':cashpotMeters:majorPanelParent'));
      this._potPanels.push(resourceManager.get(this._jsonPath + ':cashpotMeters:porkerPanelParent'));
      this._potPanels.push(resourceManager.get(this._jsonPath + ':cashpotMeters:megaPanelParent'));

      // Mini
      // right
      this._potTextMini = resourceManager.get(this._jsonPath + ':cashpotMeters:miniPanelParent:miniPanel:cashpotText');
      this._potTextMiniOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:miniPanelParent:miniPanel:cashpotTextOverlay'
      );
      this._potTextMiniOverlay.visible = false;
      // left
      this._potTextMiniLeft = resourceManager.get(
        this._jsonPath + ':cashpotMeters:miniPanelParent:miniPanelLeft:cashpotText'
      );
      this._potTextMiniLeftOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:miniPanelParent:miniPanelLeft:cashpotTextOverlay'
      );
      this._potTextMiniLeftOverlay.visible = false;

      // Minor
      // right
      this._potTextMinor = resourceManager.get(
        this._jsonPath + ':cashpotMeters:minorPanelParent:minorPanel:cashpotText'
      );
      this._potTextMinorOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:minorPanelParent:minorPanel:cashpotTextOverlay'
      );
      this._potTextMinorOverlay.visible = false;
      // left
      this._potTextMinorLeft = resourceManager.get(
        this._jsonPath + ':cashpotMeters:minorPanelParent:minorPanelLeft:cashpotText'
      );
      this._potTextMinorLeftOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:minorPanelParent:minorPanelLeft:cashpotTextOverlay'
      );
      this._potTextMinorLeftOverlay.visible = false;

      // Maxi
      // right
      this._potTextMaxi = resourceManager.get(this._jsonPath + ':cashpotMeters:maxiPanelParent:maxiPanel:cashpotText');
      this._potTextMaxiOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:maxiPanelParent:maxiPanel:cashpotTextOverlay'
      );
      this._potTextMaxiOverlay.visible = false;
      // left
      this._potTextMaxiLeft = resourceManager.get(
        this._jsonPath + ':cashpotMeters:maxiPanelParent:maxiPanelLeft:cashpotText'
      );
      this._potTextMaxiLeftOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:maxiPanelParent:maxiPanelLeft:cashpotTextOverlay'
      );
      this._potTextMaxiLeftOverlay.visible = false;

      // Major
      // right
      this._potTextMajor = resourceManager.get(
        this._jsonPath + ':cashpotMeters:majorPanelParent:majorPanel:cashpotText'
      );
      this._potTextMajorOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:majorPanelParent:majorPanel:cashpotTextOverlay'
      );
      this._potTextMajorOverlay.visible = false;
      // left
      this._potTextMajorLeft = resourceManager.get(
        this._jsonPath + ':cashpotMeters:majorPanelParent:majorPanelLeft:cashpotText'
      );
      this._potTextMajorLeftOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:majorPanelParent:majorPanelLeft:cashpotTextOverlay'
      );
      this._potTextMajorLeftOverlay.visible = false;

      // Porker
      // right
      this._potTextPorker = resourceManager.get(
        this._jsonPath + ':cashpotMeters:porkerPanelParent:porkerPanel:cashpotText'
      );
      this._potTextPorkerOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:porkerPanelParent:porkerPanel:cashpotTextOverlay'
      );
      this._potTextPorkerOverlay.visible = false;
      // left
      this._potTextPorkerLeft = resourceManager.get(
        this._jsonPath + ':cashpotMeters:porkerPanelParent:porkerPanelLeft:cashpotText'
      );
      this._potTextPorkerLeftOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:porkerPanelParent:porkerPanelLeft:cashpotTextOverlay'
      );
      this._potTextPorkerLeftOverlay.visible = false;

      // Mega
      // right
      this._potTextMega = resourceManager.get(this._jsonPath + ':cashpotMeters:megaPanelParent:megaPanel:cashpotText');
      this._potTextMegaOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:megaPanelParent:megaPanel:cashpotTextOverlay'
      );
      this._potTextMegaOverlay.visible = false;

      this._backingStarburst = resourceManager.get('mainReelsContainer:starburstContainer');
      this._backingStarburst.visible = false;
      // right
      this._potTextMegaLeft = resourceManager.get(
        this._jsonPath + ':cashpotMeters:megaPanelParent:megaPanelLeft:cashpotText'
      );
      this._potTextMegaLeftOverlay = resourceManager.get(
        this._jsonPath + ':cashpotMeters:megaPanelParent:megaPanelLeft:cashpotTextOverlay'
      );
      this._potTextMegaLeftOverlay.visible = false;

      this._backingStarburst = resourceManager.get('mainReelsContainer:starburstContainer');
      this._backingStarburst.visible = false;
    }

    onOrientationChange() {
      // this.updatePotValues();
    }

    onStakeChanged() {
      if (!gdk.getServerParser().addingRecoveryToQueue) {
        this.updatePotValues();
      }
    }

    updatePotValues() {
      let persistenValues = gameController.getPersistentValues(gameController.getCurrentModeStake(), true);

      let multi = (gameController.getCurrentModeStake(true) / 100) * 5;
      this._potValueMini = persistenValues.miniJackpotLevel * multi;
      this._potValueMinor = persistenValues.minorJackpotLevel * multi;
      this._potValueMaxi = persistenValues.maxiJackpotLevel * multi;
      this._potValueMajor = persistenValues.majorJackpotLevel * multi;
      this._potValuePorker = persistenValues.porkerJackpotLevel * multi;
      this._potValueMega = persistenValues.megaJackpotLevel * multi;
      this.setPotText('Mini', this._potValueMini);
      this.setPotText('Minor', this._potValueMinor);
      this.setPotText('Maxi', this._potValueMaxi);
      this.setPotText('Major', this._potValueMajor);
      this.setPotText('Porker', this._potValuePorker);
      this.setPotText('Mega', this._potValueMega);
    }

    updateFromPersistentValue(data, name) {
      switch (name) {
        case 'mega': {
          this._potValueMega = data / 2;
          this.setPotText('Mega', this._potValueMega);
          break;
        }
        case 'porker': {
          this._potValuePorker = data / 2;
          this.setPotText('Porker', this._potValuePorker);
          break;
        }
        case 'major': {
          this._potValueMajor = data / 2;
          this.setPotText('Major', this._potValueMajor);
          break;
        }
        case 'maxi': {
          this._potValueMaxi = data / 2;
          this.setPotText('Maxi', this._potValueMaxi);
          break;
        }
        case 'minor': {
          this._potValueMinor = data / 2;
          this.setPotText('Minor', this._potValueMinor);
          break;
        }
        case 'mini': {
          this._potValueMini = data / 2;
          this.setPotText('Mini', this._potValueMini);
          break;
        }
      }
    }

    setPotText(level, value) {
      const potTexts = {
        Mini: this._potTextMini,
        Minor: this._potTextMinor,
        Maxi: this._potTextMaxi,
        Major: this._potTextMajor,
        Porker: this._potTextPorker,
        Mega: this._potTextMega,
      };
      potTexts[level]?.setText(gdk.formatCurrency(value, false));

      const potLeftTexts = {
        Mini: this._potTextMiniLeft,
        Minor: this._potTextMinorLeft,
        Maxi: this._potTextMaxiLeft,
        Major: this._potTextMajorLeft,
        Porker: this._potTextPorkerLeft,
        Mega: this._potTextMegaLeft,
      };
      potLeftTexts[level]?.setText(gdk.formatCurrency(value, false));

      // Handle overlay text for Porker and Major levels
      const overlayTexts = {
        Mega: this._potTextMegaOverlay,
        Porker: this._potTextPorkerOverlay,
        Major: this._potTextMajorOverlay,
        Maxi: this._potTextMaxiOverlay,
        Minor: this._potTextMinorOverlay,
        Mini: this._potTextMiniOverlay,
      };

      if (overlayTexts[level]) {
        const overlayText = overlayTexts[level];
        overlayText.setText(gdk.formatCurrency(value, false));
        if (layoutController.getCurrentLayout() === 'landscape_mobile') {
          // because we use flipped panels!!!
          const scale = potLeftTexts[level].scale.x;
          const x = potLeftTexts[level].x;
          overlayText.scale.set(scale / 2);
          overlayText.x = x + overlayText.width / 2;
        } else {
          const scale = potTexts[level].scale.x;
          const x = potTexts[level].x;
          overlayText.scale.set(scale / 2);
          overlayText.x = x - overlayText.width / 2;
        }
      }

      // i dont think these are needed anymore!!
      const overlayLeftTexts = {
        Mega: this._potTextMegaLeftOverlay,
        Porker: this._potTextPorkerLeftOverlay,
        Major: this._potTextMajorLeftOverlay,
        Maxi: this._potTextMaxiLeftOverlay,
        Minor: this._potTextMinorLeftOverlay,
        Mini: this._potTextMiniLeftOverlay,
      };

      if (overlayLeftTexts[level]) {
        const overlayText = overlayLeftTexts[level];
        overlayText.setText(gdk.formatCurrency(value, false));
        const scale = potLeftTexts[level].scale.x;
        const x = potLeftTexts[level].x;
        overlayText.scale.set(scale / 2);
        overlayText.x = x + overlayText.width / 2;
      }
    }

    positionOverlaysOverText() {
      // sneaky way to position the overlays when we need to
      // this.updatePotValues();
    }

    getPotValue(level) {
      const potValues = {
        Mini: this._potValueMini,
        Minor: this._potValueMinor,
        Maxi: this._potValueMaxi,
        Major: this._potValueMajor,
        Porker: this._potValuePorker,
        Mega: this._potValueMega,
      };
      return potValues[level] ?? -1;
    }

    // i know i should convert text to a meter
    // but the auto fit seems to be different and i cant be bothered
    async countUpPotFromTo(level, fromValue, toValue, instant = false) {
      const currentStake = gameController.getCurrentModeStake(true);
      const multi = (currentStake / 100) * 5;

      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      const data = {
        value: fromValue * multi,
      };

      const duration = instant ? 0 : 0.75;

      const tween = gsap.fromTo(
        data,
        {
          value: fromValue * multi,
        },
        {
          value: toValue * multi,
          duration: duration,
          ease: 'power1.out',
          onUpdate: () => {
            this.setPotText(level, data.value);
            if (!instant && gameController.skipCurrentPiggieAnims) {
              // stake panel is shown, jump to end
              // not the best but its all i can think of at the mo
              if (tween.isActive() || tween.time() < tween.startTime()) {
                console.log(`SKIP: skipping countUpPotFromTo ${level}`);
                tween.totalProgress(1);
              }
            }
          },
          onComplete: () => {
            data.value = toValue * multi;
            this.setPotText(level, data.value);
            resolver();
          },
        }
      );

      switch (level) {
        case 'Mini':
          this._potValueMini = data.value;
          break;
        case 'Minor':
          this._potValueMinor = data.value;
          break;
        case 'Maxi':
          this._potValueMaxi = data.value;
          break;
        case 'Major':
          this._potValueMajor = data.value;
          break;
        case 'Porker':
          this._potValuePorker = data.value;
          break;
        case 'Mega':
          this._potValueMega = data.value;
          break;
      }
      await promise;
    }
  }

  create = function (json) {
    return new PotDisplay();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('potDisplay', create, initialise, getFilesRequired);
})();
